import React from 'react'
import {ColorPalette} from "../../../../fields3/color-coding/color-coding"

export enum BackGround {
    GRAY    = 'gray',
    WHITE   = 'white',
    PALE    = 'pale'
}

type Props = {
    title       : string
    value       : BackGround

    options?    : BackGround[]
    paleColor?  : number

    onChange    : {(value: BackGround):void}
    className?  : string
}

export default function SettingsBackground(props:Props) {

    const options = _.get(props, 'options', [BackGround.GRAY, BackGround.WHITE])

    const getColorClass = (value: BackGround) => {
        switch (value) {
            case BackGround.GRAY    : return 'ui5-bg-gray-8'
            case BackGround.WHITE   : return 'ui5-bg-white'
            case BackGround.PALE    : return 'pale-background'
        }
    }

    const getColorStyle = (value: BackGround) => {
        switch (value) {
            case BackGround.GRAY    :
            case BackGround.WHITE   : return undefined
            case BackGround.PALE    :
                if (!props.paleColor) return undefined
                else return {
                    backgroundColor : gd.skin.colors.paleBGColor({colorNumber: props.paleColor, corePalette: ColorPalette.CORE}),
                    borderColor     : gd.skin.colors.paleBorderColor({colorNumber: props.paleColor, corePalette: ColorPalette.CORE})
                }
        }
    }

    return (
        <div className={Classes("settings-background flex-row-left-center", props.className)}>
            <div className="label">{props.title}</div>
            <div className="options">
                <div className="flex-row-left-center">
                    {_.map(options, (option:BackGround, key: number)=>{
                        const classes = Classes("ui5-color-picker s-30 with-border", getColorClass(option), {
                            'm-l-10': key !== 0
                        })

                        const style = getColorStyle(option)

                        return (
                            <div key={option} className={classes} style={style} onClick={()=>props.onChange(option)}>
                                {props.value === option &&
                                    <div className="ui5-ico-selected s-15"/>}
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}